import api from 'config/axiosConfig';

export const getServices = () => {
  return api.get('api/services', {
    'Accept-Language': 'cn',
  });
};
